import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { loginWithCode } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // This will handle the entire Magic authentication flow
      const result = await loginWithCode(email);
      if (result.success) {
        navigate('/generator');
      } else {
        setError(result.error || 'Authentication failed');
      }
    } catch (err) {
      setError('Failed to log in');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#FDF7FF] to-[#F5EFFF]">
      <div className="max-w-md w-full p-6 bg-white/60 backdrop-blur-sm rounded-2xl shadow-lg">
        <h2 className="text-3xl font-bold text-center mb-8 bg-gradient-to-r from-[#FF3366] to-[#7C3AED] text-transparent bg-clip-text">
          Sign In / Sign Up
        </h2>
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
              placeholder="Enter your email"
              required
            />
          </div>
          {error && (
            <p className="text-red-500 text-sm">{error}</p>
          )}
          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-3 px-6 text-center text-white bg-gradient-to-r from-[#FF3366] to-[#7C3AED] rounded-full hover:shadow-lg transition-all duration-300 disabled:opacity-50"
          >
            {isLoading ? 'Authenticating...' : 'Continue with Email'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login; 